import { Link } from 'react-router-dom';
import type { SearchUser } from '@/services/api/users';
import { matchLinkFor, summariseMatch } from './match-summary';

interface MatchCellProps {
  user: SearchUser;
}

// The row click opens the user; each match deep-links to the tab holding the matched record.
export const MatchCell = ({ user }: MatchCellProps) => {
  const matches = user.matches ?? [];
  if (!matches.length) return <span className="italic text-muted-foreground">unknown</span>;

  return (
    <ul className="flex flex-col gap-1">
      {matches.map((match, index) => {
        const summary = summariseMatch(match);
        return (
          <li className="flex items-center gap-2 whitespace-nowrap text-xs" key={`${match.source}-${match.payoutAccountId ?? match.transactionId ?? index}`}>
            <Link className="font-medium text-blue-500 hover:underline" onClick={(event) => event.stopPropagation()} to={matchLinkFor(user, summary.tab)}>
              {summary.kind}
            </Link>
            <span className="text-muted-foreground">{summary.detail}</span>
          </li>
        );
      })}
    </ul>
  );
};
MatchCell.displayName = 'MatchCell';
